"use strict";
import * as React from "react";
import { useSelector } from "react-redux";
import { useCookies } from "react-cookie";
import Link from "@mui/material/Link";

import { getSystemDatetime, getDatetimeByYmdhms, getDateByYmd, formatDateYmd, formatDateNumber } from "../../common/utils/DateUtils";
import { PathInfoList } from "../../_constants/PathInfoList";
import { viewId, titleName } from "../../_constants/Code";
import { errorLog } from "../../common/logger/Logger";
import { Message } from "../../_components/MessagePage";
import { getObjectList } from "../../common/utils/FileUtils";

import '../../assets/css/vendor/normalize.css'
import '../../assets/css/vendor/animate.min.css'
import '../../assets/css/vendor/hamburgers.css'
import '../../assets/icon/style.css'
import '../../assets/css/style.css'
import '../../assets/js/tailwindcss.js'
import '../../assets/js/adobe_fonts.js'

//@GlobalCustomizeFunction
const Cookie = () => {
  try {
    const [cookies, setCookie] = useCookies();
    const updateLastDay = () => {
      const date = getSystemDatetime();
      let expires = getSystemDatetime();
      expires.setFullYear(expires.getFullYear() + 5);
      setCookie(
        "lastNewsViewDatetime",
        date.toLocaleString({ timeZone: "Asia/Tokyo" }),
        { expires: expires, path: "/" }
      );
    };

    React.useEffect(() => {
      updateLastDay();
    }, []);
  } catch (error) {
    errorLog("E000001", this.props.userId, viewId.news, "Cookie", error);
  }

  return null;
};

const Nodata = () => {
  const messageList = [
    "ニュース情報はありません。",
  ];
  return (
    <Message
      title="人的資本関連ニュース一覧"
      messageList={messageList}
      loginBtn={false}
      topBtn={false}
    />
  );
};

const Error = () => {
  const messageList = [
    "ニュース情報の取得に失敗しました。画面を再表示してください。",
  ];
  return (
    <Message
      title="人的資本関連ニュース一覧"
      messageList={messageList}
      loginBtn={false}
      topBtn={false}
    />
  );
};

class NewsContent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoaded: false,
      //@ComponentState
      marker: 10,
    };
    //@Component
    this.newsList_ = [];
    this.isError = false;
    this.loadList = this.loadList.bind(this);
  }

  //@CustomizeFunction
  getNews = async () => {
    try {
      const newsList = await getObjectList(process.env.REACT_APP_S3_WEB_CHROFY_COMMON, PathInfoList.Folder.newsFolder + PathInfoList.Objectkeyname.news);
      this.newsList_ = this.generateNewsList(newsList);
    } catch (error) {
      this.isError = true;
      errorLog("E000001", this.props.userId, viewId.news, "getNews", error);
    } finally {
      this.setState({
        isLoaded: true,
      });
    }
  };

  generateNewsList = (data) => {
    let newsList = data.map((data) => {
      return (
        {
          date: formatDateNumber(data.date),
          title: data.title,
          url: data.url,
          // guide: data.guide // ガイド分表示機能を一時オミット
        }
      )
    });
    newsList = newsList.sort((a, b) => {
      return a.date > b.date ? -1 : 1; //オブジェクトの降順ソート
    });
    let today = getSystemDatetime();
    newsList = newsList
      .filter((news) => {
        const pubDate = getDatetimeByYmdhms(news.date);
        return pubDate <= today;
      })
      .map((news) => {
        const date = getDateByYmd(news.date);
        date.setDate(date.getDate() + 1);
        date.setMonth(date.getMonth() + 1);
        let isNew = false;
        if (today <= date) {
          isNew = true;
        }
        return {
          date: formatDateYmd(news.date),
          title: news.title,
          url: news.url,
          // guide: news.guide, // ガイド分表示機能を一時オミット
          isNew: isNew,
        };
      });
    return newsList;
  }

  loadList() {
    try {
      this.setState({
        marker: this.state.marker + 10,
      });
    } catch (error) {
      errorLog("E000001", this.props.userId, viewId.news, "loadList", error);
    }
  }

  componentDidMount = async () => {
    // タイトル設定
    document.title = this.props.pageTitle;
    this.getNews();
  };
  render() {
    if (!this.state.isLoaded) {
      return null;
    }
    if (this.isError) {
      return <Error />;
    }
    if (this.newsList_.length <= 0) {
      return <Nodata />;
    }
    const newsList = this.newsList_.map((news, index) => {
      if (news.url == null || news.url == "" || news.url.length == 0) {
        return (<li key={index} className="news-list__item">
          <div className="news-list__link flex pt-6 pb-7" target="_blank">
            {news.isNew && <span className="news-list__new text-h6-en red white--text px-5 py-1.5 rounded-lg absolute">NEW</span>}
            <span className="news-list__date grey--text text--lighten-70 text-right mr-8">{news.date}</span>
            <span className="grey--text text--lighten-70 text-right mr-8">
              {news.title}
              {/* ガイド分表示機能を一時オミット
              <br></br>
              <span className="grey--text text--lighten-70 text-right mr-8">
                {news.guide}
              </span>
              */}
            </span>
          </div>
        </li>);
      } else {
        return (<li key={index} className="news-list__item">
          <div className="news-list__link flex pt-6 pb-7" target="_blank">
            {news.isNew && <span className="news-list__new text-h6-en red white--text px-5 py-1.5 rounded-lg absolute">NEW</span>}
            <span className="news-list__date grey--text text--lighten-70 text-right mr-8">{news.date}</span>
            <span className="news-list__title grow">
              <Link color="inherit" href={news.url} target="_blank">
                {news.title}
              </Link>
              {/* ガイド分表示機能を一時オミット
              <br></br>
              <span className="grey--text text--lighten-70 text-right mr-8">
                {news.guide}
              </span>
              */}
            </span>
          </div>
        </li>);
      }
    });
    return (
      <main className="page-container">
        <Cookie />
        <section className="page-content">
          <div className="centered-container">
            {/* コンテンツヘッダ */}
            <header className="page-header flex justify-center py-1">
              <h1 className="page-header__name text-h1 grey--text py-16">人的資本関連ニュース一覧 </h1>
            </header>

            {/* コンテンツボディ */}
            <div className="page-body">
              {/* ===== ニュース一覧 ===== */}
              <div className="news-list">
                <ul className="news-list__list">
                  {newsList.slice(0, this.state.marker)}
                </ul>
              </div>
              {/* ===== /ニュース一覧 ===== */}
              <div className="text-center mt-16">
                {this.newsList_.length > this.state.marker ? (
                  <button className="btn btn-more white--text grey rounded-lg px-16 font-medium" onClick={this.loadList}>もっと見る</button>
                ) : (
                  ""
                )}
              </div>
            </div>
          </div>
        </section>
      </main>
    );
  }
}

const News = () => {
  const state = useSelector((state) => state);
  return <NewsContent
    userId={state.user.sub}
    pageTitle={titleName.news + titleName.common}
  />;
};

export default News;
